<template>
  <div class="brands-page all-modifier all-modifier-groups page inner-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col
                cols="2"
                style="min-width: 100px; max-width: 100%"
                class="flex-grow-1 flex-shrink-0"
              >
                <div>
                  <v-text-field
                    v-model="searchQuery"
                    prepend-inner-icon="search"
                    label="Search Modifier Groups"
                    class="toWhite"
                    flat
                    hide-details
                    single-line
                    solo
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="2" v-if="userType > 8">
                <v-btn
                  :ripple="false"
                  depressed
                  class="gen-button white--text"
                  color="#60a45f"
                  @click="openModifierGroup"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Modifier Group</span>
                </v-btn>
              </v-col>
              <!-- <v-col cols="2" v-if="userType > 8">
                <v-btn
                  :ripple="false"
                  depressed
                  class="gen-button"
                  @click="openModifier"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Modifier</span>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>

          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="10">
                <v-data-table
                  :headers="headers"
                  :items="filteredSearchResult"
                  item-key="id"
                  class="elevation-0 dataTableUI staffTable border-me-light"
                >
                  <!-- For Image -->
                  <template v-slot:[`item.image`]="{ item }">
                    <v-img
                      :src="item.image || require('@/assets/imgUpload.jpg')"
                      height="50px"
                      width="50px"
                      style="margin: 0 auto"
                    ></v-img>
                  </template>

                  <!-- For Names -->
                  <template v-slot:[`item.name`]="{ item }">
                    {{ item.name }}
                  </template>

                  <!-- For Category -->
                  <template v-slot:[`item.categories`]="{ item }">
                    <span v-if="item.categories[0]">
                      {{ item.categories[0].name }}
                    </span>
                  </template>

                  <!-- For Brand -->
                  <template v-slot:[`item.menubrand`]="{ item }">
                    <span v-if="item.menubrand">{{
                      item.menubrand.brandName
                    }}</span>
                  </template>

                  <!-- For Item Status -->
                  <template v-slot:[`item.isAvailable`]="{ item }">
                    <v-switch
                      v-model="item.isAvailable"
                      :disabled="userType < 9"
                      @change="
                        switchModifierAvailability(item.id, item.isAvailable)
                      "
                      style="max-width: 50px; margin: 0 auto !important"
                      color="primary"
                      hide-details
                      inset
                      class="ma-0"
                    ></v-switch>
                  </template>

                  <!-- For Actions -->
                  <template
                    v-slot:[`item.action`]="{ item, index }"
                    v-if="userType > 8"
                  >
                    {{ index }}
                    {{ item.index }}
                    <v-btn
                      :ripple="false"
                      x-small
                      text
                      class="white py-4 btn-outlined"
                      @click="
                        openModifier('editMode', item);
                        isEditMode = true;
                      "
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span class="mx-2"></span>
                    <v-btn
                      :ripple="false"
                      text
                      x-small
                      class="white py-4 btn-outlined"
                      @click="
                        deleteMenu(item.id);
                        loaderNum = index;
                      "
                      ><v-icon>delete_forever</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
              <!-- <v-col cols="2" class="col-2-side-tab">
                <div class="col-2-side-tab-wrapper max-height">
                  <div
                    class="switch-tab no-bg"
                    :class="{ activeSwitchTab: filterDataBy == undefined }"
                  >
                    <v-btn
                      :ripple="false"
                      text
                      depressed
                      width="100%"
                      left
                      class="justify-start transparent switch-tab gen-button no-Btn-bg"
                      @click="
                        filterDataBy = undefined;
                        currentSwitchTab = '';
                      "
                    >
                      <strong>All Modifier Groups</strong>
                    </v-btn>
                  </div>

                  <div
                    v-for="(group, index) in groups"
                    :key="index"
                    :class="{ activeSwitchTab: group.id == currentSwitchTab }"
                    class="switch-tab"
                  >
                    <v-btn
                      :ripple="false"
                      text
                      depressed
                      width="100%"
                      left
                      class="justify-start transparent switch-tab gen-button no-Btn-bg"
                      @click="
                        filterDataBy = group.Modifiers;
                        $forceUpdate();
                        currentSwitchTab = group.id;
                      "
                    >
                      {{ group.name }}
                    </v-btn>
                  </div>
                </div>
              </v-col> -->
            </v-row>
          </div>

          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Modifier -->
                <div v-if="addNewModifierActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add New Modifier</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <div><b>Group Name</b></div>
                        <v-text-field
                          v-model="getGroupName"
                          hide-details
                          outlined
                          placeholder="Enter group name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <div><b>Status</b></div>
                        <v-select
                          v-model="status"
                          class="text-capitalize"
                          hide-details
                          outlined
                          append-icon="arrow_drop_down"
                          :items="['active', 'inactive']"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      :loading="loader"
                      color="#468346"
                      class="white--text"
                      @click="addNewModifier"
                    >
                      Ok
                    </v-btn>
                  </div>
                </div>

                <!-- Add New Modifier Group -->
                <div v-if="addNewModifierGroupActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Group</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="groupName"
                          outlined
                          hide-details
                          label="Group Name"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field
                          v-model="min"
                          outlined
                          hide-details
                          label="Minimum"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field
                          v-model="max"
                          outlined
                          hide-details
                          label="Maximum"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addNewGroup"
                      >Ok</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      title: "Modifier Groups",
      dataReady: false,
      num: -1,
      isEditMode: false,
      loader: false,
      currentID: "",
      currentSwitchTab: "",
      filterDataBy: undefined,
      headers: [
        {
          text: "Group",
          align: "start",
          sortable: true,
          value: "name",
        },
        // {
        //   text: "Price",
        //   align: "center",
        //   value: "price",
        // },
        {
          text: "Status",
          align: "center",
          justify: "center",
          value: "isAvailable",
        },
        // {
        //   text: "Action",
        //   align: "center",
        //   sortable: false,
        //   value: "action",
        // },
      ],
      groupName: "",
      min: "",
      max: "",
      getGroupName: "",
      modifierGroup: "",
      price: "",
      status: true,
      openDialog: false,
      addNewModifierGroupActive: false,
      addNewModifierActive: false,
      rules: {
        required: (value) => !!value || "Required",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      searchQuery: "",
    };
  },
  methods: {
    openModifier(edit, data) {
      this.addNewModifierGroupActive = false;
      this.addNewModifierActive = true;
      this.openDialog = true;

      if (edit == "editMode") {
        this.addNewModifierActive = true;
        this.openDialog = true;

        this.currentID = data.id;

        this.getGroupName = data.name;
        this.modifierGroup = data.modifierGroup;
        this.price = data.price;
        data.isAvailable == true
          ? (this.status = "active")
          : (this.status = "inactive");
      } else {
        this.addNewModifierActive = true;
        this.openDialog = true;
      }
    },
    openModifierGroup() {
      this.addNewModifierActive = false;
      this.addNewModifierGroupActive = true;
      this.openDialog = true;
    },
    addNewGroup() {
      //   Start Loader
      this.loader = true;

      axios
        .post(
          "/api/v1/modifiergroup",
          {
            name: this.groupName,
            minimum: this.min,
            maximum: this.max,
          },
          { headers: { Authorization: this.$store.state.token } }
        )
        .then(() => {
          this.$store.dispatch("getAllGroups");

          this.addNewModifierGroupActive = false;
          this.openDialog = false;

          //   Stop Loader
          this.loader = false;
        })
        .catch(() => {
          this.addNewModifierGroupActive = false;
          this.openDialog = false;

          //   Stop Loader
          this.loader = false;
        });
    },
    addNewModifier() {
      //   Start Loader
      this.loader = true;
      if (!this.isEditMode) {
        // if it is not edit mode

        axios
          .post(
            "/api/v1/modifier",
            {
              name: this.getGroupName,
              groupId: this.modifierGroup,
              price: this.price,
              isAvailable: this.status == "active" ? true : false,
            },
            { headers: { Authorization: this.$store.state.token } }
          )
          .then(() => {
            this.$store.dispatch("getAllModifiers");

            this.addNewModifierActive = false;
            this.openDialog = false;

            //   Stop Loader
            this.loader = false;
          })
          .catch(() => {
            this.addNewModifierActive = false;
            this.openDialog = false;

            //   Stop Loader
            this.loader = false;
          });
      } else if (this.isEditMode) {
        // if it is edit mode

        axios
          .put(
            "/api/v1/modifier/" + this.currentID,
            {
              name: this.getGroupName,
              groupId: this.modifierGroup,
              price: this.price,
              isAvailable: this.status == "active" ? true : false,
            },
            { headers: { Authorization: this.$store.state.token } }
          )
          .then(() => {
            this.$store.dispatch("getAllModifiers");

            this.currentID = ""; // VERY IMPORTANT: Always negate data after each edit request
            this.isEditMode = false; // VERY IMPORTANT: Always negate data after each edit request

            this.addNewModifierActive = false;
            this.openDialog = false;

            //   Stop Loader
            this.loader = false;
          })
          .catch(() => {
            this.currentID = ""; // VERY IMPORTANT: Always negate data after each edit request
            this.isEditMode = false; // VERY IMPORTANT: Always negate data after each edit request

            this.addNewModifierActive = false;
            this.openDialog = false;

            //   Stop Loader
            this.loader = false;
          });
      }
    },
    deleteModifier(id) {
      //   Start Loader
      this.loader = true;

      axios
        .delete("/api/v1/modifier/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.$store.dispatch("getAllModifiers");

          //   Stop Loader
          this.loader = false;
        })
        .catch(() => {
          //   Stop Loader
          this.loader = false;
        });
    },
    switchModifierAvailability(id, isAvailable) {
      //   Start Loader
      this.loader = true;

      let url = "";
      isAvailable == false
        ? (url = "/api/v1/modifiergroup/" + id + "?status=unavailable")
        : (url = "/api/v1/modifiergroup/" + id + "?status=available");
      axios
        .patch(
          url,
          {},
          {
            headers: { Authorization: this.$store.state.token },
          }
        )
        .then(() => {
          this.$store.dispatch("getAllModifiers");

          this.snackBar.active = true;
          this.snackBar.text = "Status updated successfully";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        })
        .catch(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Status update failed";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        });
    },
  },
  watch: {
    groups(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
    openDialog(val) {
      if (val == false) {
        this.$refs.dialogForm.reset();
      }
    },
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.groups;
      // let grabArr2 = this.groups;
      const filterDataBy = this.filterDataBy;

      if (filterDataBy == undefined) {
        // continue with normal flow
        grabArr = this.groups;
      } else if (filterDataBy.length > 0) {
        grabArr = filterDataBy;
      } else if (filterDataBy.length == 0) {
        grabArr = [];
      }

      return grabArr.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1 // search by name
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "allModifiers", "groups", "userType"]),
  },
  created() {
    this.$store.dispatch("getAllGroups");
    // this.$store.dispatch("getAllModifiers");
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style></style>
